import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../../colorVars';
import style from './CancelOrderButton.module.css';

export const CancelOrderButton = ({ width, clickHandler, margin }) => {
  return (
    <svg
      className={style.svg}
      width={width}
      height={width}
      style={{ margin }}
      onClick={clickHandler}
    >
      <circle
        cx={width / 2}
        cy={width / 2}
        r={width / 2 - width / 10}
        strokeWidth={2}
        stroke="white"
        fill={colors.red}
      />
      <line
        x1={width - width / 10 - 2}
        y1={width / 10 + 2}
        x2={width / 10 + 2}
        y2={width - width / 10 - 2}
        stroke="white"
        strokeWidth={2}
      />
    </svg>
  );
};

CancelOrderButton.propTypes = {
  width: PropTypes.number.isRequired,
  clickHandler: PropTypes.func,
  margin: PropTypes.string
};
